var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLendingPools(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.3982 18.2299C69.4731 16.3428 58.3279 20.0403 50.6975 28.0836L29.4477 50.4833L50.8721 70.808L72.122 48.4081C79.7524 40.365 82.8581 29.0403 80.3982 18.2299Z",
    stroke: "url(#paint0_linear_623_5300)",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0186 53.8709L26.2436 61.0123L40.5266 74.5621L47.3016 67.4207",
    stroke: "url(#paint1_linear_623_5300)",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4219 56.5252L70.8843 76.2242L64.1093 83.3658L50.8721 70.8082",
    stroke: "url(#paint2_linear_623_5300)",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9976 36.2005L22.9856 30.7844L16.2106 37.9258L29.4477 50.4835",
    stroke: "url(#paint3_linear_623_5300)",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.829 23.0077L76.8679 42.0179",
    stroke: "url(#paint4_linear_623_5300)",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0282 88.7217L64.1092 83.3655",
    stroke: "url(#paint5_linear_623_5300)",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1295 43.2817L16.2105 37.9256",
    stroke: "url(#paint6_linear_623_5300)",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6459 77.6356C27.775 79.6078 16.3917 84.4556 16.3917 84.4556C16.3917 84.4556 20.6334 72.833 22.5043 70.8609C24.3752 68.8888 27.4905 68.8067 29.4626 70.6775C31.4347 72.5484 31.5167 75.6635 29.6459 77.6356Z",
    stroke: "url(#paint7_linear_623_5300)",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3982 18.23L89.1694 8.98415",
    stroke: "url(#paint8_linear_623_5300)",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0565 48.0974C59.579 50.709 55.4536 50.8176 52.8421 48.3402C50.2306 45.8627 50.1219 41.7376 52.5994 39.126C55.0768 36.5145 59.2022 36.4058 61.8137 38.8833C64.4253 41.3607 64.5339 45.4859 62.0565 48.0974Z",
    stroke: "url(#paint9_linear_623_5300)",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5878 46.9749L54.5779 47.0345L54.5878 46.9749ZM54.5878 46.9749L54.6235 46.9861",
    fill: "url(#paint10_linear_623_5300)",
    stroke: "url(#paint11_linear_623_5300)",
    strokeWidth: 5.12
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_623_5300",
    x1: 82.2731,
    y1: 64.9258,
    x2: -21.7485,
    y2: -10.0533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_623_5300",
    x1: 47.4319,
    y1: 72.3668,
    x2: 5.99961,
    y2: 42.5021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_623_5300",
    x1: 70.9995,
    y1: 80.598,
    x2: 23.9974,
    y2: 55.6983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_623_5300",
    x1: 43.3138,
    y1: 48.203,
    x2: 2.1682,
    y2: 8.05614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_623_5300",
    x1: 76.8183,
    y1: 40.136,
    x2: 38.0656,
    y2: 12.2029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_623_5300",
    x1: 64.2334,
    y1: 88.0812,
    x2: 53.8754,
    y2: 80.6153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_623_5300",
    x1: 16.3348,
    y1: 42.6413,
    x2: 5.97673,
    y2: 35.1754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_623_5300",
    x1: 31.2196,
    y1: 82.6311,
    x2: 1.71417,
    y2: 61.3633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_623_5300",
    x1: 89.3838,
    y1: 17.1244,
    x2: 71.5035,
    y2: 4.23621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_623_5300",
    x1: 63.982,
    y1: 48.6995,
    x2: 38.1179,
    y2: 30.0563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_623_5300",
    x1: 62.4929,
    y1: 41.1848,
    x2: 52.1136,
    y2: 39.2056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB9025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567708,
    stopColor: "#B246FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_623_5300",
    x1: 62.5634,
    y1: 42.6075,
    x2: 47.989,
    y2: 36.9567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLendingPools);
export default __webpack_public_path__ + "static/media/lending-pools.07fe1d6b255d3a9984d19574f673f530.svg";
export { ForwardRef as ReactComponent };